import { Check } from 'lucide-react';
import { twMerge as cn } from 'tailwind-merge';

export interface OnboardingStep {
  id: number;
  title: string;
  description: string;
}

interface OnboardingStepperProps {
  steps: OnboardingStep[];
  currentStep: number;
  className?: string;
}

function OnboardingStepper({
  steps,
  currentStep,
  className,
}: OnboardingStepperProps) {
  return (
    <div className={cn('onboarding-stepper-strip', className)}>
      <div className="flex w-full border-x border-gray-300 divide-x divide-gray-300">
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;

          return (
            <div
              key={step.id}
              className={cn(
                'relative flex min-w-0 flex-1 flex-col gap-4 p-6',
                isActive ? 'bg-surface-muted' : 'bg-white'
              )}
            >
              {index < steps.length - 1 && (
                <div
                  className={cn(
                    'absolute left-[3.5rem] right-0 top-[2.75rem] z-[1] h-[3px] rounded-full',
                    isCompleted ? 'bg-accent' : 'bg-gray-300'
                  )}
                  aria-hidden
                />
              )}

              <div className="relative z-10 flex shrink-0">
                <div
                  className={cn(
                    'onboarding-step-dot',
                    isCompleted || isActive
                      ? 'onboarding-step-dot--active'
                      : 'onboarding-step-dot--inactive'
                  )}
                >
                  {isCompleted ? (
                    <Check className="h-5 w-5" strokeWidth={2.5} />
                  ) : (
                    <span>{step.id}</span>
                  )}
                </div>
              </div>

              <div className="space-y-1">
                <h3
                  className={cn(
                    'font-semibold text-sm',
                    isActive || isCompleted ? 'text-black' : 'text-brand'
                  )}
                >
                  {step.title}
                </h3>
                <p className="pr-4 text-xs leading-relaxed text-gray-500">
                  {step.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OnboardingStepper;
